import baseApi from './baseApi';

export type SocialMediaData = { [key: string]: SocialMediaUsername };
export type SocialMediaUsername = {
  username: string;
};

// Define a service using a base URL and expected endpoints
export const socialMediaInfoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSocialMediaInfo: builder.query<SocialMediaData, string | null>({
      query: (siteId) => `/api/theme/sites/${siteId}/branding-theme/social`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSocialMediaInfoQuery } = socialMediaInfoApi;
